module.exports = __webpack_public_path__ + "img/020070.f69901e9.png";